export default {
  'projects.cohortBuilder.subjectsColumnHeader.personId': 'Person ID',
  'projects.cohortBuilder.subjectsColumnHeader.gender': 'Gender',
  'projects.cohortBuilder.subjectsColumnHeader.race': 'Race',
  'projects.cohortBuilder.subjectsColumnHeader.ethnicity': 'Ethnicity',
  'projects.cohortBuilder.subjectsColumnHeader.age': 'Age',

  // workflow message
  'projects.cohortBuilder.cohortSubjectsPageTab.title': 'Subjects',
  'projects.cohortBuilder.cohortSubjectsPageTab.draft.title': 'No subjects',
  'projects.cohortBuilder.cohortSubjectsPageTab.draft.message':
    'Process the cohort to view the list of subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortSubjectsPageTab.processing.title': 'Processing subjects',
  'projects.cohortBuilder.cohortSubjectsPageTab.processing.message':
    'The list of subjects who meet all cohort criteria will be available once cohort processing is complete.',
  'projects.cohortBuilder.cohortSubjectsPageTab.error.title': 'No subjects',
  'projects.cohortBuilder.cohortSubjectsPageTab.error.message':
    'Edit and re-process the cohort to view the list of subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortSubjectsPageTab.processedNoData.title': 'No subjects',
  'projects.cohortBuilder.cohortSubjectsPageTab.processedNoData.message':
    'Edit and re-process the cohort to view the list of subjects who meet all cohort criteria.',
};
